import React, {useState } from 'react';
import {
    TableData,
    TableRow,
    InputBox,
    CheckMarkImg,
    NoMatchError,
    DownArrow,
    UpArrow,
    RemoveIcon,
    AddIcon
} from './index.styled.jsx';
import {Spinner } from 'src/common/refactoredComponents/searchDropdown/SearchDropdown.styled.jsx';
import TruncatedTooltip from './TruncatedTooltip';
import {
    ActionButton
} from 'src/common/organisms/setsanditems/SetsAndItems.styled.jsx';
import {
    AddedCartButton,
    Counter,
    Type,
} from './index.styled.jsx';
import TemplateCheckBox from './TemplateCheckBox';
import CheckBoxTransfer from './CheckBoxTransfer';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import BatchDropDown from 'src/common/components/batchDropDown';
import AddCartButton from '../../atomics/addCartButton/AddCartButton';
import AddCartIcon from '../../atomics/addCartButton/AddCartIcon';
import { isTransferSurgery, logErrorToConsole, getCartCount } from 'src/utils/util';
import { ITEMSDETAILS } from 'src/pages/equity/components/common/constants';
import BOMChanges from 'src/assets/images/BOMChanges.svg';
import StorageRequest from 'src/assets/images/storage-request.svg';
import TissueItemIcon from 'src/assets/images/TissueItemIcon.svg';
import { setCurrencyFormatWithoutSymbol } from 'src/utils/util.js';
import {
    FONT_FAMILY_DEMI,
    SEMANTIC_TEXT_SMALL_PX,
    DARK_NAVY_FONT_COLOR,
} from 'src/styles/fonts/MCFontConstants';
import CheckMark from 'src/assets/images/CheckMark.svg';
import { useTranslation } from 'react-i18next';
import BrandCell from './BrandCell';
import DeleteButtonCell from './DeleteButtonCell';
import PriceCell from './PriceCell';
import { TITLE_FONT_COLOR, X_SMALL_TEXT_PX } from '../../../styles/fonts/MCFontConstants';
import CountBadge from '../../refactoredComponents/countBadge/CountBadge';
import { useSelector } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging.js';

const ListViewTableRow = ({
    index,
    parentIndex,
    isSubItem,
    isBundleView,
    item,
    expandedItems,
    countryISOCode,
    isReviewSubmitScreenEquity,
    isForProductGuide,
    isForSetItem,
    isSurgery,
    isTablet,
    toggleItem,
    isQuickOrder,
    handleSetItemClick,
    isTemplateScreen,
    isReviewSubmitScreen,
    isShippingScreen,
    isOrderScreen,
    productBomDetails,
    onBomClick,
    winWidth,
    NonTissueItemIcon,
    isFromSetItemDetailsLists,
    getMaxLength,
    isItemListView,
    orderType,
    isFromTemplates,
    isCondensedView,
    isAddToBundle,
    handleCheckBoxSelection,
    productKeyBundle,
    productWithIsPlaceHolderSet,
    inventoryShipping,
    showDontShip,
    shipDontShipSurgery,
    handleLocationChange,
    selectedLocation,
    allocatedData,
    checkAll,
    setIsBatchSelected,
    isBatchSelected,
    setAllocatedData,
    setReservationBatch,
    isCartScreen,
    moreTemplates,
    removeCount,
    isItemBundlePopup,
    isEquityPage,
    isEquityTemplate,
    validateQuantity,
    addCount,
    isFromIndependentProductGuide,
    isClickAllowed,
    handleAddToCartSynchronized,
    setProductToBeAdded,
    isConsignmentAdd,
    productValidation,
    StepperAddBlue,
    isEquity,
    isOnlyPlusButton,
    deleteProduct,
    isQuickOrderEquityTemplate,
    cartProducts,
    isFromEquity,
}) => {
    const { t } = useTranslation();
    
    // iPad detection logic
    const isIPad = (winWidth >= 760 && winWidth <= 775) ||  // iPad Mini
                   (winWidth >= 805 && winWidth <= 825) ||  // iPad 9th Gen & iPad Air
                   (winWidth >= 1020 && winWidth <= 1030);  // iPad Pro
    const loadingStatusArray = useSelector(
        (state) => state.validateProductsReducer?.loadingStatusArray || []
    );
    const consignmentAddLoadingStatusArray = useSelector(
        (state) => state.consignmentAddValidateProductsReducer?.loadingStatusArray || []
    );
    const equityLoadingStatusArray = useSelector(
        (state) => state.equityValidateProductsReducer?.loadingStatusArray || []
    );
    const equitypricingStatusArray = useSelector(
        (state) => state.getPricesForItemsReducer?.pricingStatusArray || []
    );
    const validatedProducts = useSelector((state) =>
        isEquityPage
            ? state.equityValidateProductsReducer?.validatedProducts || []
            : isConsignmentAdd
            ? state.consignmentAddValidateProductsReducer?.validatedProducts || []
            : state.validateProductsReducer?.validatedProducts || []
    );

    const isProductLoading = 
    isFromEquity?
    ((Array.isArray(equityLoadingStatusArray)
        ? equityLoadingStatusArray.some(
              (product) =>
                  product?.loading &&
                  product?.cfn === (item?.cfn || item?.productCFN)
          ) :
        Array.isArray(equitypricingStatusArray)
        ? equitypricingStatusArray.some(
              (product) =>
                  product?.loading &&
                  product?.cfn === (item?.cfn || item?.productCFN) &&
                  (product?.salesOrg === item?.salesOrg)
          )
        : false))
    : isConsignmentAdd?
     (Array.isArray(consignmentAddLoadingStatusArray)
        ? consignmentAddLoadingStatusArray.some(
              (product) =>
                  product?.loading &&
                  product?.cfn === (item?.cfn || item?.productCFN) &&
                  (product?.salesOrg === item?.salesOrg)
          ) : false)
    : Array.isArray(loadingStatusArray)
        ? loadingStatusArray.some(
              (product) =>
                  product?.loading &&
                  product?.cfn === (item?.cfn || item?.productCFN) &&
                  (product?.salesOrg === item?.salesOrg)
          )
        : false;

    const matchedValidatedProduct = Array.isArray(validatedProducts)
        ? validatedProducts.find(
              (product) =>
                  (product?.cfn || product?.productCFN) ===
                      (item?.cfn || item?.productCFN) &&
                  product?.salesOrg === item?.salesOrg
          )
        : null;
    const isProductAdded = Boolean(
        item?.productAdded || matchedValidatedProduct?.productAdded
    );
    const cartCount = getCartCount(cartProducts, item);
    const [isAddPending, setIsAddPending] = useState(false);

    useEffectWithErrorLogging(() => {
        if (isProductLoading) {
            setIsAddPending(true);
            return;
        }

        if (!isAddPending) {
            return undefined;
        }

        if (matchedValidatedProduct || isProductAdded) {
            setIsAddPending(false);
            return undefined;
        }

        const timer = setTimeout(() => {
            setIsAddPending(false);
        }, 300);

        return () => clearTimeout(timer);
    }, [
        isAddPending,
        isProductAdded,
        isProductLoading,
        matchedValidatedProduct,
    ]);

    const shouldShowLoader = isProductLoading || isAddPending;

    return (
        <>
            <TableRow
                key={index}
                index={index}
                parentIndex={parentIndex}
                isSubItem={isSubItem}
                isBundleView={isBundleView}
                style={{
                    verticalAlign:
                        (item.adjustedExtPrice ||
                            item.adjustedUnitPrice) &&
                        'top',
                    borderBottom:
                        expandedItems[
                            item.productKey || index
                        ] ||
                            item?.businessRules
                                ?.length > 0 ||
                            item.batchAllocationError ||
                            (isTransferSurgery() &&
                                item.status &&
                                (countryISOCode === 'JP'
                                    ? item.status !==
                                    'Not Allocated'
                                    : true)) ||
                            isSubItem
                            ? ''
                            : '1px solid #ddd',
                }}
            >
                <TableData
                    ipadPadding={'0px'}
                    ipadAirPadding={'0px'}
                    isReviewSubmitScreenEquity={
                        isReviewSubmitScreenEquity
                    }
                    width={
                        isForProductGuide &&
                            isForSetItem
                            ? '17%'
                            : '25%'
                    }
                    className="product"
                    isSubItem={isSubItem}
                >
                    <div
                        style={{
                            width:
                                isSurgery &&
                                    isTablet
                                    ? '160px'
                                    : isSurgery &&
                                    '200px',
                            display: 'flex',
                            flexDirection: 'row',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        <div
                            style={{
                                width:
                                    isSurgery &&
                                        isTablet
                                        ? '110px'
                                        : isSurgery &&
                                        '130px',
                                paddingRight: '5px',
                            }}
                        >
                            {(item &&
                                item.materialType &&
                                item.materialType ==
                                ITEMSDETAILS[2]
                                    .materialType[
                                'bundle'
                                ]) ||
                                (Object.prototype.hasOwnProperty.call(
                                    item,
                                    'bundleItems'
                                ) &&
                                    item.bundleItems
                                        ?.length >
                                    0) ? (
                                expandedItems[
                                    item.productKey ||
                                    index
                                ] ? (
                                    <UpArrow
                                        id={`item.expand-icon-${item.productCFN || item.cfn || item.bom || index}`}
                                        onClick={() =>
                                            toggleItem(
                                                item.productKey ||
                                                index
                                            )
                                        }
                                    />
                                ) : (
                                    <DownArrow
                                        id={`item.collapse-icon-${item.productCFN || item.cfn || item.bom || index}`}
                                        onClick={() =>
                                            toggleItem(
                                                item.productKey ||
                                                index
                                            )
                                        }
                                    />
                                )
                            ) : null}
                            <span
                                style={{
                                    marginLeft: isQuickOrder && (isIPad ? '5px' : '5px'),
                                    cursor:
                                        isQuickOrder ? 'not-allowed' : 'pointer',
                                    pointerEvents: isQuickOrder ? 'none' : 'auto',
                                    color: isQuickOrder
                                        ? '#130e4a'
                                        : TITLE_FONT_COLOR,
                                    fontWeight:
                                        '500',
                                }}
                                onClick={() => {
                                    try {
                                        handleSetItemClick(
                                            item
                                        );
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                id={`add-cart-btn-${item.productCFN ||
                                    item.cfn ||
                                    item.bom ||
                                    ''
                                    }`}
                            >
                                {item.productCFN ||
                                    item.cfn ||
                                    item.bom}
                            </span>
                            {(item?.isPlusIconDisable && isQuickOrder) && (
                                <NoMatchError>
                                    {t('scheduleSurgery.quickOrder.noMatchingProductFound')}
                                </NoMatchError>
                            )}
                        </div>
                        <div>
                            {!isTemplateScreen &&
                                !isReviewSubmitScreen &&
                                !isReviewSubmitScreenEquity &&
                                !isShippingScreen &&
                                item.isSet &&
                                !isOrderScreen &&
                                (productBomDetails.find(
                                    (bomDetail) =>
                                        bomDetail.prodcutCFN ===
                                        item.productCFN
                                )
                                    ?.billOfMaterialsHistory ? (
                                    <span id={`item-bom-icon-${item.productCFN || item.cfn || item.bom || index}`}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                        onClick={() =>
                                            onBomClick(
                                                item
                                            )
                                        }
                                    >
                                        {' '}
                                        <img
                                            src={
                                                BOMChanges
                                            }
                                            alt="BOM"
                                            width="25px"
                                            height="15px"
                                            style={{
                                                marginLeft:
                                                    winWidth >=
                                                        '768' &&
                                                        winWidth <
                                                        '900'
                                                        ? '0'
                                                        : '-5px',
                                                marginBottom:
                                                    '-2px',
                                            }}
                                        />
                                    </span>
                                ) : (
                                    <div
                                        style={{
                                            width:
                                                isSurgery &&
                                                '20px',
                                        }}
                                    ></div>
                                ))}
                        </div>
                        <div>
                            {item?.isReservationSet &&
                                !isOrderScreen &&
                                !isTemplateScreen ? (
                                <span>
                                    <img
                                        src={
                                            StorageRequest
                                        }
                                        alt="storage-request"
                                        width="25px"
                                        height="15px"
                                        style={{
                                            marginLeft:
                                                '0',
                                            marginBottom:
                                                '-3px',
                                        }}
                                    />
                                </span>
                            ) : (
                                <div
                                    style={{
                                        width:
                                            isSurgery &&
                                            '24px',
                                    }}
                                ></div>
                            )}
                        </div>
                    </div>
                </TableData>
                {countryISOCode === 'US' &&
                    !isForProductGuide &&
                    !isForSetItem && (
                        <TableData>
                            <div
                                style={{
                                    display: 'flex',
                                    marginLeft:
                                        '5px',
                                }}
                            >
                                {!(
                                    (item.materialType &&
                                        item.materialType ==
                                        ITEMSDETAILS[2]
                                            .materialType[
                                        'bundle'
                                        ]) ||
                                    (Object.prototype.hasOwnProperty.call(
                                        item,
                                        'bundleItems'
                                    ) &&
                                        item
                                            .bundleItems
                                            ?.length >
                                        0)
                                ) &&
                                    item.salesOrg ===
                                    'S030' &&
                                    countryISOCode ===
                                    'US' && (
                                        <span>
                                            <img
                                                src={
                                                    TissueItemIcon
                                                }
                                                alt="T"
                                                style={{
                                                    height: '15px',
                                                    width: '34px',
                                                    marginBottom:
                                                        '-3px',
                                                }}
                                            />
                                        </span>
                                    )}
                                {!(
                                    (item.materialType &&
                                        item.materialType ==
                                        ITEMSDETAILS[2]
                                            .materialType[
                                        'bundle'
                                        ]) ||
                                    (Object.prototype.hasOwnProperty.call(
                                        item,
                                        'bundleItems'
                                    ) &&
                                        item
                                            .bundleItems
                                            ?.length >
                                        0)
                                ) &&
                                    item.salesOrg ===
                                    'S002' &&
                                    countryISOCode ===
                                    'US' && (
                                        <span>
                                            <img
                                                src={
                                                    NonTissueItemIcon
                                                }
                                                alt="T"
                                                style={{
                                                    height: '15px',
                                                    width: '34px',
                                                    marginBottom:
                                                        '-3px',
                                                }}
                                            />
                                        </span>
                                    )}
                            </div>
                        </TableData>
                    )}
                <TableData
                    ipadPaddingLeft={'10px !important'}
                    ipadAirPaddingLeft={'10px !important'}

                    isReviewSubmitScreenEquity={
                        isReviewSubmitScreenEquity
                    }
                    width={
                        isReviewSubmitScreen ||
                            isReviewSubmitScreenEquity
                            ? isReviewSubmitScreenEquity
                                ? '47%'
                                : '20%'
                            : isForProductGuide &&
                                isForSetItem
                                ? '45%'
                                : '36%'
                    }
                    isForProductGuide={isForProductGuide}
                    isFromSetItemDetailsLists={isFromSetItemDetailsLists}
                    className="description"
                >
                    {item.description && (
                        <TruncatedTooltip
                            isOrderScreen={
                                isOrderScreen
                            }
                            isTemplateScreen={
                                isTemplateScreen
                            }
                            text={item.description}
                            maxLength={getMaxLength(
                                'description'
                            )}
                            productCfn={
                                item.productCFN ||
                                item.cfn ||
                                item.bom
                            }
                        />
                    )}
                </TableData>
                {(isTemplateScreen ||
                    isOrderScreen) && (
                        <>
                            {!(
                                Object.prototype.hasOwnProperty.call(
                                    item,
                                    'bundleItems'
                                ) &&
                                item.bundleItems
                                    ?.length > 0
                            ) && (
                                    <TableData
                                        width="15%"
                                        className="brand"
                                    >
                                        {item.brand && (
                                            <BrandCell
                                                item={item}
                                                getMaxLength={getMaxLength}
                                                isOrderScreen={isOrderScreen}
                                                isTemplateScreen={isTemplateScreen}
                                            />
                                        )}
                                    </TableData>
                                )}
                            {Object.prototype.hasOwnProperty.call(
                                item,
                                'bundleItems'
                            ) &&
                                item.bundleItems
                                    ?.length > 0 && (
                                    <TableData
                                        width="15%"
                                        className="brand"
                                        padding={
                                            '8px 13px'
                                        }
                                    >
                                        {item
                                            ?.bundleItems
                                            ?.length > 0
                                            ? item
                                                .bundleItems
                                                ?.length
                                            : ''}
                                    </TableData>
                                )}
                            {isOrderScreen &&
                                !isSubItem &&
                                !isItemListView &&
                                orderType !== 'KE' &&
                                orderType !== 'KB' && (
                                    <TableData>
                                        {item.status}
                                    </TableData>
                                )}
                            <TableData
                                width="16%"
                                className="quantityUoM"
                            >
                                {item.quantity} X{' '}
                                <Type
                                    style={{
                                        fontSize:
                                            X_SMALL_TEXT_PX,
                                    }}
                                >
                                    {/* {item.uom} */}
                                    {item.isSet
                                        ? t(
                                            'common.setLabel'
                                        )
                                        : item.uom}
                                </Type>
                            </TableData>
                            {!isOrderScreen &&
                                !isFromTemplates && (
                                    <TableData className="quantity" >
                                        <TemplateCheckBox
                                            isCondensedView={
                                                isCondensedView
                                            }
                                            isAddToBundle={
                                                isAddToBundle
                                            }
                                            item={item}
                                            checkBoxDetails={{
                                                name: item.cfn,
                                                id: item.description,
                                                onChange:
                                                    () => {
                                                        (item &&
                                                            item.materialType &&
                                                            item.materialType ==
                                                            ITEMSDETAILS[2]
                                                                .materialType[
                                                            'bundle'
                                                            ]) ||
                                                            isSubItem
                                                            ? handleCheckBoxSelection(
                                                                isSubItem
                                                                    ? item.cfn
                                                                    : item.productKey,
                                                                !item.isChecked,
                                                                isSubItem
                                                                    ? 'children'
                                                                    : 'parent',
                                                                isSubItem
                                                                    ? productKeyBundle
                                                                    : '',
                                                                !item.isChecked
                                                            )
                                                            : handleCheckBoxSelection(
                                                                item.productKey,
                                                                !item.isChecked
                                                            );
                                                    },
                                                checked:
                                                    item.isChecked,
                                            }}
                                            productWithIsPlaceHolderSet={
                                                productWithIsPlaceHolderSet
                                            }
                                        />
                                    </TableData>
                                )}
                        </>
                    )}
                {isReviewSubmitScreen && (
                    <TableData
                        width="16%"
                        className="brand"
                    >
                        {item.brand && (
                            <BrandCell
                                item={item}
                                getMaxLength={getMaxLength}
                                isOrderScreen={isOrderScreen}
                                isTemplateScreen={isTemplateScreen}
                            />
                        )}
                    </TableData>
                )}
                {isReviewSubmitScreenEquity &&
                    !isBundleView && (
                        <TableData
                            isReviewSubmitScreenEquity={
                                isReviewSubmitScreenEquity
                            }
                            width="16%"
                            className="brand"
                        >
                            {item.brand && (
                                <BrandCell
                                    item={item}
                                    getMaxLength={getMaxLength}
                                    isOrderScreen={isOrderScreen}
                                    isTemplateScreen={isTemplateScreen}
                                />
                            )}
                        </TableData>
                    )}
                {isReviewSubmitScreenEquity &&
                    isBundleView && (
                        <TableData
                            width="16%"
                            className="brand"
                            padding={'8px 13px'}
                        >
                            {item?.children
                                ?.length > 0
                                ? item.children
                                    .length
                                : ''}
                        </TableData>
                    )}
                {isShippingScreen ||
                    isReviewSubmitScreen ||
                    isReviewSubmitScreenEquity ? (
                    <>
                        <TableData
                            isReviewSubmitScreenEquity={
                                isReviewSubmitScreenEquity
                            }
                            width={
                                isReviewSubmitScreenEquity
                                    ? '12%'
                                    : '16%'
                            }
                            className="quantityUoM"
                        >
                            {item.quantity} X{' '}
                            <Type
                                style={{
                                    fontSize:
                                        X_SMALL_TEXT_PX,
                                }}
                            >
                                {item.isSet
                                    ? t(
                                        'common.setLabel'
                                    )
                                    : item.uom}
                            </Type>
                        </TableData>
                        {isReviewSubmitScreenEquity &&
                            !isSubItem && !isItemBundlePopup && (
                                <TableData
                                    isReviewSubmitScreenEquity={
                                        isReviewSubmitScreenEquity
                                    }
                                    className="price"
                                    width={
                                        isReviewSubmitScreenEquity &&
                                        '12%'
                                    }
                                >
                                    <div
                                        style={{
                                            textDecoration:
                                                item.adjustedUnitPrice &&
                                                'line-through',
                                            color:
                                                item.adjustedUnitPrice &&
                                                '#E5047E',
                                        }}
                                    >
                                        {setCurrencyFormatWithoutSymbol(
                                            item.basePrice
                                        )}
                                    </div>
                                    {item.adjustedUnitPrice && (
                                        <div>
                                            {setCurrencyFormatWithoutSymbol(
                                                item.adjustedUnitPrice
                                            )}
                                        </div>
                                    )}
                                </TableData>
                            )}
                        {isReviewSubmitScreenEquity &&
                            !isSubItem && !isItemBundlePopup && (
                                <TableData
                                    isReviewSubmitScreenEquity={
                                        isReviewSubmitScreenEquity
                                    }
                                    className="price"
                                    width={
                                        isReviewSubmitScreenEquity &&
                                        '12%'
                                    }
                                >
                                            <PriceCell
                                                extPrice={setCurrencyFormatWithoutSymbol(item.extPrice)}
                                                adjustedExtPrice={item.adjustedExtPrice && setCurrencyFormatWithoutSymbol(item.adjustedExtPrice)}
                                                discount={item.discount}
                                                t={t}
                                                isUnit={false}
                                            />
                                </TableData>
                            )}
                        {!isReviewSubmitScreen &&
                            !isReviewSubmitScreenEquity &&
                            showDontShip && (
                                <TableData className="quantity" padding={'0 0 0 10px'}>
                                    {shipDontShipSurgery !==
                                        'NOT_VISIBLE' &&
                                        item?.isSet &&
                                        !item.isReservationSet &&
                                        (isTransferSurgery() &&
                                            item.status &&
                                            (countryISOCode ===
                                                'JP'
                                                ? item.status !==
                                                'Not Allocated'
                                                : true) ? (
                                            <CheckBoxTransfer
                                                item={
                                                    item
                                                }
                                                inventoryShipping={
                                                    inventoryShipping || item?.isPlaceHolderAdded
                                                }
                                                countryISOCode={
                                                    countryISOCode
                                                }
                                                handleLocationChange={
                                                    handleLocationChange
                                                }
                                                checked={
                                                    !item.shippingRequirement
                                                }
                                                selectedLocation={
                                                    selectedLocation
                                                }
                                                allocatedData={
                                                    allocatedData
                                                }
                                                isShowCheckBox={
                                                    true
                                                }
                                                isMessageDisplay={
                                                    false
                                                }
                                                isShowLabelEmpty={
                                                    true
                                                }
                                                isShowDropDown={
                                                    false
                                                }
                                            />
                                        ) : (
                                            <Checkbox
                                                checked={!item.shippingRequirement}
                                                onCheckboxSelectionChange={(e) => {
                                                    if (
                                                        !inventoryShipping && !item?.isPlaceHolderAdded
                                                    ) {
                                                        handleLocationChange(
                                                            item.productKey,
                                                            !item.shippingRequirement
                                                        );
                                                    }
                                                }}
                                                disabled={inventoryShipping || item?.isPlaceHolderAdded}
                                                id='dont-ship-shipping-requirement-checkbox'
                                                margin={'0 6px 0 0'}
                                                labelStyleObj={{
                                                    fontSize: SEMANTIC_TEXT_SMALL_PX,
                                                    fontFamily: FONT_FAMILY_DEMI,
                                                    color: DARK_NAVY_FONT_COLOR,
                                                }}
                                                background={'none'}
                                                checkboxBorder={'1.5px solid #555555'}
                                                alignItemDirection={'center'}
                                                hoverEffect={'false'}
                                                disableFocusEffect={'true'}
                                            />
                                        ))}
                                </TableData>
                            )}
                        <TableData
                            width={
                                isShippingScreen
                                    ? '28%'
                                    : '18%'
                            }
                            className="batch"
                        >
                            {isShippingScreen &&
                                showDontShip &&
                                (shipDontShipSurgery !==
                                    'NOT_VISIBLE' ||
                                    item.isReservationSet) && (
                                    <BatchDropDown
                                        checkAll={
                                            checkAll
                                        }
                                        checked={
                                            !item.shippingRequirement
                                        }
                                        countryISOCode={
                                            countryISOCode
                                        }
                                        selectedLocation={
                                            selectedLocation
                                        }
                                        setIsBatchSelected={
                                            setIsBatchSelected
                                        }
                                        isBatchSelected={
                                            isBatchSelected
                                        }
                                        allocatedData={
                                            allocatedData
                                        }
                                        setAllocatedData={
                                            setAllocatedData
                                        }
                                        setReservationBatch={
                                            setReservationBatch
                                        }
                                        product={
                                            item
                                        }
                                        isShowCheckBox={
                                            false
                                        }
                                        isMessageDisplay={
                                            false
                                        }
                                        isShowLabelEmpty={
                                            false
                                        }
                                        isShowSetLocation={
                                            false
                                        }
                                        isShowDropDown={
                                            true
                                        }
                                    />
                                )}
                        </TableData>
                    </>
                ) : (
                    !isTemplateScreen &&
                    !isOrderScreen && (
                        <>
                            {!isBundleView && (
                                <TableData
                                    width={
                                        isForProductGuide &&
                                            isForSetItem
                                            ? '20%'
                                            : '16%'
                                    }
                                    padding={isSurgery && isCartScreen && '8px 10px'}
                                    className="brand"
                                >
                                    {item.brand && (
                                        <BrandCell
                                            item={item}
                                            getMaxLength={getMaxLength}
                                            isOrderScreen={isOrderScreen}
                                            isTemplateScreen={isTemplateScreen}
                                        />
                                    )}
                                </TableData>
                            )}
                            {isBundleView && (
                                <TableData
                                    width="15%"
                                    className="brand"
                                    padding={
                                        '8px 13px'
                                    }
                                >
                                    {item?.children
                                        ?.length >
                                        0 ||
                                        item
                                            ?.bundleItems
                                            ?.length > 0
                                        ? item
                                            ?.children
                                            ?.length ||
                                        item
                                            ?.bundleItems
                                            ?.length
                                        : ''}
                                </TableData>
                            )}
                            {!isForProductGuide &&
                                !isForSetItem && (
                                    <TableData
                                        className="quantity"
                                        width={
                                            isBundleView &&
                                            '13%'
                                        }
                                    >
                                        <ActionButton>
                                            <>
                                                <AddCartButton
                                                    className={
                                                        item.quantity <=
                                                            0 ||
                                                            item.isPlaceHolderAdded ||
                                                                item.isDeleteButtonPresent ===
                                                            false
                                                            ? 'disabled'
                                                            : ''
                                                    }
                                                    width={
                                                        '20px'
                                                    }
                                                    height={
                                                        '29px'
                                                    }
                                                    border={
                                                        'unset'
                                                    }
                                                    visibility={
                                                        item.isDeleteButtonPresent ===
                                                            false
                                                            ? 'hidden'
                                                            : ''
                                                    }
                                                    id={`item-decrease-quantity-${item.productCFN || item.cfn || item.bom || index}`}
                                                    style={{ marginLeft: '-6px' }}
                                                    onClick={() => {
                                                        try {
                                                            if (
                                                                moreTemplates
                                                            ) {
                                                                if (
                                                                    isSubItem
                                                                ) {
                                                                    const childKey = isEquityTemplate ? 
                                                                        (item?.productCFN ||
                                                                        item?.cfn ||
                                                                        item?.bom ||
                                                                        item?.productKey) : item?.productKey
                                                                    removeCount(
                                                                        childKey,
                                                                        item.materialType,
                                                                        index,
                                                                        childKey,
                                                                        true,
                                                                        'Bundle',
                                                                        productKeyBundle
                                                                    );
                                                                } else {
                                                                    removeCount(
                                                                        item.cfn,
                                                                        item.isSet,
                                                                        index,
                                                                        item?.productKey
                                                                    );
                                                                }
                                                            } else {
                                                                if (
                                                                    isSubItem
                                                                ) {
                                                                    removeCount(
                                                                        item.productKey,
                                                                        item.isSet,
                                                                        item,
                                                                        productKeyBundle
                                                                    );
                                                                } else if (
                                                                    isItemBundlePopup
                                                                ) {
                                                                    removeCount(
                                                                        item
                                                                    );
                                                                } else {
                                                                    removeCount(
                                                                        item.productKey ??
                                                                        item.cfn, // use productKey if exists, else cfn
                                                                        item.isSet, // pass isSet if exists, else undefined
                                                                        item // pass item itself
                                                                    );
                                                                }
                                                            }
                                                        } catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }}
                                                    shadow={
                                                        'none'
                                                    }
                                                >
                                                    <RemoveIcon />
                                                </AddCartButton>
                                            </>
                                            {isEquityPage ||
                                                isEquityTemplate ? (
                                                <InputBox
                                                    type="text"
                                                    disabled={item.isPlusIconDisable && isQuickOrder}

                                                    value={
                                                        item.quantity ===
                                                            '0'
                                                            ? ''
                                                            : item.quantity
                                                    }
                                                    onChange={(
                                                        e
                                                    ) => {
                                                        validateQuantity(
                                                            e
                                                                .target
                                                                .value,
                                                            productKeyBundle,
                                                            isEquityTemplate ? 
                                                                        (item?.productKey ||
                                                                        item?.cfn ||
                                                                        item?.bom ||
                                                                        item?.productCFN) : item?.productKey
                                                        );
                                                    }}
                                                />
                                            ) : (
                                                <Counter
                                                    color={
                                                        '#030330'
                                                    }
                                                    style={{
                                                        fontFamily:
                                                            'AvenirNextWorld Regular',
                                                        fontSize:
                                                            '14px',
                                                    }}
                                                >
                                                    {
                                                        item.quantity
                                                    }
                                                </Counter>
                                            )}
                                            <>
                                                <AddCartButton
                                                    className={
                                                        isQuickOrder
                                                            ? (item.isPlusIconDisable
                                                                ? 'disabled'
                                                                : item.quantity >= 50 ||
                                                                    item.isPlaceHolderAdded ||
                                                                    (
                                                                        // !isSubItem &&
                                                                        !item.isSet &&
                                                                        item.isDeleteButtonPresent === false)
                                                                    ? 'disabled'
                                                                    : '')
                                                            : (item.quantity >= 50 ||
                                                                item.isPlaceHolderAdded ||
                                                                (
                                                                    // !isSubItem &&
                                                                    !item.isSet &&
                                                                    item.isDeleteButtonPresent === false)
                                                                ? 'disabled'
                                                                : '')
                                                    }
                                                    visibility={
                                                        isEquityPage ||
                                                            isEquityTemplate
                                                            ? ''
                                                            : 
                                                            // !isSubItem &&
                                                                !item.isSet &&
                                                                item.isDeleteButtonPresent ===
                                                                false
                                                                ? 'hidden'
                                                                : ''
                                                    }
                                                    width={
                                                        '20px'
                                                    }
                                                    height={
                                                        '29px'
                                                    }
                                                    border={
                                                        'unset'
                                                    }
                                                    id={`item-increase-quantity-${item.productCFN || item.cfn || item.bom || index}`}
                                                    onClick={() => {
                                                        try {
                                                            if (
                                                                moreTemplates
                                                            ) {
                                                                if (
                                                                    isEquityTemplate
                                                                ) {
                                                                    if (
                                                                        isSubItem
                                                                    ) {
                                                                        const childKey = isEquityTemplate ? 
                                                                        (item?.productCFN ||
                                                                        item?.cfn ||
                                                                        item?.bom ||
                                                                        item?.productKey) : item?.productKey
                                                                        addCount(
                                                                            childKey,
                                                                            item.materialType,
                                                                            '',
                                                                            item.quantity,
                                                                            'bundle',
                                                                            productKeyBundle
                                                                        );
                                                                    } else {
                                                                        addCount(
                                                                            item.cfn,
                                                                            item.isSet,
                                                                            '',
                                                                            item.quantity
                                                                        );
                                                                    }
                                                                } else {
                                                                    addCount(
                                                                        item
                                                                    );
                                                                }
                                                            } else {
                                                                if (
                                                                    isSubItem
                                                                ) {
                                                                    addCount(
                                                                        item,
                                                                        productKeyBundle
                                                                    );
                                                                } else if (
                                                                    isItemBundlePopup
                                                                ) {
                                                                    addCount(
                                                                        item
                                                                    );
                                                                } else {
                                                                    addCount(
                                                                        item
                                                                    );
                                                                }
                                                            }
                                                        } catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }}
                                                    shadow={
                                                        'none'
                                                    }
                                                >
                                                    <AddIcon />
                                                </AddCartButton>
                                            </>
                                        </ActionButton>
                                    </TableData>
                                )}
                            {!isForProductGuide &&
                                !isForSetItem && (
                                    <TableData
                                        width={
                                            isEquityPage
                                                ? isSubItem &&
                                                '6%'
                                                : isItemBundlePopup
                                                    ? '11%'
                                                    : '5%'
                                        }
                                        className="uom"
                                    >
                                        {item?.isSet || item?.uom ?
                                            <Type
                                                marginLeft={'0px'}
                                                style={{
                                                    fontSize:
                                                        X_SMALL_TEXT_PX,
                                                }}
                                            >
                                                {item.isSet
                                                    ? t(
                                                        'common.setLabel'
                                                    )
                                                    : item.uom}
                                            </Type>
                                            : null}
                                    </TableData>
                                )}
                            {isForProductGuide &&
                                !isForSetItem &&
                                !isFromIndependentProductGuide && (
                                    <TableData
                                        width={
                                            '16%'
                                        }
                                    >
                                        <ActionButton>
                                            <Type marginLeft={'0px'}>
                                                {item.isSet
                                                    ? t(
                                                        'common.setLabel'
                                                    )
                                                    : item.uom}
                                            </Type>
                                                <>
                                                <AddedCartButton
                                                    hasBadge={!isProductLoading && !item.productAdded}
                                                    noShrink={isIPad}
                                                    ipadMarginLeft={isIPad ? '2px' : '0px'}
                                                    onClick={() => {
                                                        try {
                                                            const itemKey = item.cfn || item.productCFN || item.id;
                                                            if (!isClickAllowed(itemKey)) {
                                                                return;
                                                            }
                                                            if (handleAddToCartSynchronized) {
                                                                handleAddToCartSynchronized(item);
                                                            } else {
                                                                setProductToBeAdded(item);
                                                                productValidation && productValidation([item]);
                                                            }
                                                        } catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }}
                                                    id={`add-cart-btn-${item.cfn || item.bom || ''}`}
                                                >
                                                { shouldShowLoader?
                                                    <Spinner />:
                                                    isProductAdded ? 
                                                    <img
                                                        src={CheckMark}
                                                        width="30px"
                                                        height="30px"
                                                    />
                                                    :
                                                    <>
                                                    <AddCartIcon
                                                        mobilePath={
                                                            StepperAddBlue
                                                        }
                                                        width={
                                                            '19px'
                                                        }
                                                        height={
                                                            '19px'
                                                        }
                                                    />
                                                    <CountBadge 
                                                    count={cartCount} 
                                                    />
                                                    </>
                                                    }
                                                </AddedCartButton>
                                                </>
                                        </ActionButton>
                                    </TableData>
                                )}
                            {isEquityPage &&
                                !isSubItem && !isItemBundlePopup && (
                                    <TableData className="price">
                                        <div
                                            style={{
                                                textDecoration:
                                                    item.adjustedUnitPrice &&
                                                    'line-through',
                                                color:
                                                    item.adjustedUnitPrice &&
                                                    '#E5047E',
                                            }}
                                        >
                                            {setCurrencyFormatWithoutSymbol(
                                                item.basePrice
                                            )}
                                        </div>
                                        {item.adjustedUnitPrice && (
                                            <div>
                                                {setCurrencyFormatWithoutSymbol(
                                                    item.adjustedUnitPrice
                                                )}
                                            </div>
                                        )}
                                    </TableData>
                                )}
                            {isForSetItem && (
                                <TableData
                                    isReviewSubmitScreenEquity={
                                        isReviewSubmitScreenEquity
                                    }
                                    width={
                                        isReviewSubmitScreenEquity
                                            ? '12%'
                                            : '16%'
                                    }
                                    className="quantityUoM"
                                >
                                    {item?.isSet ? (
                                        <Type
                                            style={{
                                                fontSize:
                                                    X_SMALL_TEXT_PX,
                                            }}
                                        >
                                            {t(
                                                'common.setLabel'
                                            )}
                                        </Type>
                                    ) : (
                                        <>
                                            {
                                                item.quantity
                                            }{' '}
                                            X{' '}
                                            <Type
                                                style={{
                                                    fontSize:
                                                        X_SMALL_TEXT_PX,
                                                }}
                                            >
                                                {
                                                    item.uom
                                                }
                                            </Type>
                                        </>
                                    )}
                                </TableData>
                            )}

                            {isForSetItem && (
                                <TableData>
                                    {!(
                                        isConsignmentAdd ||
                                        isEquity
                                    ) &&
                                        isOnlyPlusButton &&
                                        isForSetItem && (
                                            <ActionButton>
                                                {item?.productAdded && (
                                                    <img
                                                        src={
                                                            CheckMark
                                                        }
                                                        width={
                                                            '30px'
                                                        }
                                                        height={
                                                            '30px'
                                                        }
                                                        alt="Added"
                                                    />
                                                )}
                                                {!item?.productAdded && (
                                                    <>
                                                    <AddedCartButton
                                                        id={`add-cart-btn-${item.cfn ||
                                                            item.bom ||
                                                            ''}`}
                                                        width={'29px'}
                                                        height={'29px'}
                                                        border={'unset'}
                                                        noShrink
                                                        onClick={() => {
                                                            try {
                                                                const itemKey = item.cfn || item.productCFN || item.id;
                                                                if (!isClickAllowed(itemKey)) {
                                                                    return;
                                                                }
                                                                if (handleAddToCartSynchronized) {
                                                                    handleAddToCartSynchronized(item);
                                                                } else {
                                                                    setProductToBeAdded(item);
                                                                    productValidation && productValidation([item]);
                                                                }
                                                            } catch (error) {
                                                                logErrorToConsole(error);
                                                            }
                                                        } }
                                                    >
                                                                <AddCartIcon
                                                                    mobilePath={StepperAddBlue}
                                                                    width={'19px'}
                                                                    height={'19px'} /> 
                                                                </AddedCartButton>
                                                    </>
                                                )}
                                            </ActionButton>
                                        )}
                                </TableData>
                            )}

                            {isEquityPage &&
                                !isSubItem && !isItemBundlePopup && (
                                    <TableData className="price">
                                        <PriceCell
                                            extPrice={setCurrencyFormatWithoutSymbol(item?.extPrice)}
                                            adjustedExtPrice={item?.adjustedExtPrice && setCurrencyFormatWithoutSymbol(item?.adjustedExtPrice)}
                                            t={t}
                                            discount={item?.discount}
                                        />
                                    </TableData>
                                )}
                            {!isForProductGuide &&
                                !isForSetItem && (
                                    <TableData
                                        className="delete"
                                        paddingDelete={
                                            isEquityPage
                                                ? 'none'
                                                : isItemBundlePopup
                                                    ? '5%'
                                                    : isBundleView ? '0%'
                                                    : '5%'
                                        }
                                    >
                                        <DeleteButtonCell
                                            item={item}
                                            index={index}
                                            isSubItem={isSubItem}
                                            isEquityTemplate={isEquityTemplate}
                                            isEquityPage={isEquityPage}
                                            isQuickOrder={isQuickOrder}
                                            isQuickOrderEquityTemplate={isQuickOrderEquityTemplate}
                                            isItemBundlePopup={isItemBundlePopup}
                                            deleteProduct={deleteProduct}
                                            productKeyBundle={productKeyBundle}
                                        />
                                    </TableData>
                                )}
                        </>
                    )
                )}
            </TableRow>
        </>
    );
};

export default ListViewTableRow;